import axios from "axios";
import SideBar from "./sidebar/ManagerSideBar";
import DashBoardNavbar from "./navbar/DashBoardNavbar";
import * as React from "react";
import { Root1, CustomTablePagination1 } from "../../config/tableOptions";
import { useNavigate } from "react-router";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "@material-ui/lab/Pagination";
import 'react-toastify/dist/ReactToastify.css';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import DeleteVideo from "../Modals/DeleteVideo";
import DeleteVideoMany from "../Modals/DeleteVideoMany";
import Spinner, { DotLoader } from "react-spinner-overlay";

function Videos() {
  const userType = sessionStorage.getItem("role") === "Deactivate";

  let navigate = useNavigate();
  const [user, setuser] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [deleteArray2, setDeleteArray2] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState(sessionStorage.getItem('search'));
  const [modal3, setModal3] = React.useState(false);
  const [modal4, setModal4] = React.useState(false);
  const [currentID, setCurrentID] = React.useState("");
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [percentage, setPercentage] = React.useState("0");
  const [dataCount, setDataCount] = React.useState(1)

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    console.log("inside socket use effect");
    const socket = new WebSocket("wss://feeds.playstream.media/websocket");
    // const socket = new WebSocket("ws://192.168.1.9:8004");


    

    socket.onopen = () => {
      console.log("WebSocket connected");
    };

    let data = 0;
    socket.onmessage = (event) => {
     let message = JSON.parse(event.data);
      if(message.type == 'video'){
      console.log(message)
      setPercentage(message.data);
      if (message.data == 100) {
        setTimeout(() => {
          getData();
          setPercentage(0);
        }, 2000);
      }
    }
    };

    return () => {
      socket.close();
    };
  }, []);

  const handleCheckboxChange = (id) => {
    if (deleteArray2.includes(id)) {
      const newArray = deleteArray2.filter((item) => item !== id);
      setDeleteArray2(newArray);
    } else {
      const tmpArr = [...deleteArray2, id];
      setDeleteArray2(tmpArr);
    }
  };

  const getData = async () => {
    setLoading(true);
    console.log("getting the videos");
    let URL = `/api/videos/items?page=${page}&limit=${pageSize}&search=${searchQuery}`
    if (sessionStorage.getItem('search') == null) {
      URL = `/api/videos/items?page=${page}&limit=${pageSize}&search=`
    }
    if (sessionStorage.getItem('limit') == null) {
      URL = `/api/videos/items?page=${page}&limit=5&search=${searchQuery}`
    }
    if (sessionStorage.getItem('search') == null && sessionStorage.getItem('limit') == null) {
      URL = `/api/videos/items?page=${page}&limit=5&search=`
    }
    let data = await axios
      .get(
        URL,
        {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("userToken"),
          },
        }
      )
      .then((response) => {
        setRows(response.data.items);
        setCount(response.data.totalPages);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);


  const handlePageChange = (event, value) => {
    console.log(value);
    setPage(value);
  };

  const handlePageSizeChange = (event) => {
    showSuccessToast(
      `Rows Per Page changed to ${parseInt(event.target.value, 10)}`
    );
    setPageSize(event.target.value);
    sessionStorage.setItem('limit', event.target.value)
  };

  // const [page, setPage] = React.useState(1);
  const [count, setCount] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(sessionStorage.getItem('limit'));

  const pageSizes = [5, 10, 25];

  React.useEffect(() => {
    getData();
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  React.useEffect(() => {
    getData();
  }, [page, pageSize]);

  const [copied, setCopied] = React.useState(false);

  const handleCopy = (videoLink) => {
    navigator.clipboard.writeText(videoLink)
      .then(() => {
        setCopied(true);
        showSuccessToast(
          'Video link copied to clipboard!'
        );
      })
      .catch((error) => {
        console.error('Error copying to clipboard:', error);
      });
  };
  React.useEffect(() => {
    let timerId;

    const handleSearch = () => {
      getData();
    };

    const throttleSearch = () => {
      clearTimeout(timerId);

      timerId = setTimeout(handleSearch, 800);
    };

    if (searchQuery !== null && searchQuery !== "") { // Add condition to check for null or empty string
      throttleSearch(); // Initial search request
    }

    return () => {
      clearTimeout(timerId); // Clean up the timer on component unmount
    };
  }, [searchQuery]);

  const Root = Root1;

  const logOut = () => {
    sessionStorage.clear();
    navigate("/login");
  };
  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    sessionStorage.setItem('search', query)
    setPage(1);
  };

  return (
    <body
      className={`overflow-hidden grad ${windowWidth <= 1200 ? "" : "g-sidenav-show"
        }`}
    >
      {/* side navbar */}
      {windowWidth >= 1200 && <SideBar />}
      <main className="main-content position-relative h-100 border-radius-lg">
        <DashBoardNavbar user={user} logOut={logOut} />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2 align-items-center">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3  justify-content-between align-items-center d-flex flex-row">
                    <h6 className="text-white text-capitalize ps-3 align-items-center">
                      All Videos
                    </h6>
                    <div className="d-flex flex-row  w-75 col-sm-4 align-items-center justify-content-end">
                      <input
                        type="text"
                        className="form-control mr-2 w-75"
                        placeholder="Search by Feed or Video Name"
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                    </div>
                  </div>
                </div>
                <div className="card-body px-4 pb-2">
                  <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                    <Root sx={{ width: 1500, maxWidth: "100%" }}>
                      {loading ? (
                        <div class="d-flex justify-content-center m-3">
                          <DotLoader
                            visible={loading}
                            textContent={"Loading..."}
                            animation="grow"
                            overlayColor="rgba(0, 0, 0, 0.5)"
                            color="#5BC0F8"
                          />
                        </div>
                      ) : (
                        <>
                          <div className="d-flex flex-row align-items-center justify-content-end">
                            {"Items per Page: "}
                            <select
                              className="mx-2"
                              onChange={handlePageSizeChange}
                              value={pageSize}
                            >
                              {pageSizes.map((size) => (
                                <option key={size} value={size}>
                                  {size}
                                </option>
                              ))}
                            </select>

                            <Pagination
                              color="primary"
                              className="my-3"
                              count={count}
                              page={page}
                              siblingCount={1}
                              boundaryCount={1}
                              variant="outlined"
                              onChange={handlePageChange}
                            />
                          </div>

                          <table aria-label="custom pagination table">
                            <thead>
                              <tr>
                                <th
                                  style={{ width: "5%" }}
                                  className="text-center"
                                >
                                  Sr No.
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Feed Name
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Video Title
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Duration
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Size
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  Creation
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="text-center"
                                >
                                  URL
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {(rowsPerPage > 0 ? rows : rows).map(
                                (row, index) => (
                                  <tr key={row._id}>
                                    <td>{(index + 1) + (pageSize * (page - 1))}</td>
                                    <td>
                                      {row.feedId && row.feedId.title
                                        ? row.feedId.title
                                        : "No Feed Name"}
                                    </td>
                                    <td>
                                      {row.name
                                        ? row.name.substring(0, 60) + "..."
                                        : "No Title Found"}
                                    </td>
                                    <td>
                                      {row.duration
                                        ? Math.floor(row.duration / 60) +
                                        " mins " +
                                        (row.duration % 60) +
                                        " sec"
                                        : "No Duration Found"}
                                    </td>
                                    <td>
                                      {row.size
                                        ? Math.round(row.size / (1024 * 1024)) +
                                        " MB"
                                        : "No Size Found"}
                                    </td>
                                    <td>
                                      {row.creation
                                        ? new Date(row.creation).toLocaleString()
                                        : "No Creation Found"}
                                    </td>
                                    <td>
                                      {row.path ? (
                                        <button
                                          style={{
                                            backgroundColor: "#F0F8FF",
                                            // #002D62
                                            color: "#034694",
                                            fontWeight: "bold",
                                            border: "2px",
                                            borderRadius: "7px",
                                            padding: "5%",
                                          }}
                                          onClick={() => handleCopy(row.path)}
                                        >
                                          <i
                                            class="fa fa-clipboard"
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Copy to Cliboard
                                        </button>
                                      ) : (
                                        <div
                                          style={{
                                            width: "100%",
                                            height: "20px",
                                            backgroundColor: "#9e9e9e",
                                            borderRadius: "10px",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: `${percentage}%`,
                                              height: "100%",
                                              backgroundColor: "#5BC0F8",
                                              transition:
                                                "width 1s ease-in-out",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "flex-end",
                                              paddingRight: "4px",
                                              color: "#fff",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {percentage}%
                                          </div>
                                        </div>
                                      )}
                                    </td>

                                    <td className="bg-gray-200 ">
                                      {!userType && (
                                        <td
                                          className="bg-gray-200 text-center"
                                          style={{ width: 240 }}
                                          align="right"
                                        >
                                          <button
                                            className="btn btn-link text-secondary mb-0"
                                            onClick={() => {
                                              setModal3(true);
                                              // deleteVideo(row._id);
                                              setCurrentID(row._id);
                                              console.log(row._id);
                                            }}
                                          >
                                            <DeleteIcon color="action" />
                                          </button>
                                          <button className="btn btn-link text-secondary mb-0"></button>
                                          {rows && (
                                            <button className="btn btn-link text-secondary mb-0">
                                              <input
                                                type="checkbox"
                                                checked={
                                                  deleteArray2.includes(
                                                    row._id
                                                  ) || false
                                                }
                                                onChange={() => {
                                                  handleCheckboxChange(row._id);
                                                  console.log(row._id);
                                                }}
                                              />
                                            </button>
                                          )}
                                        </td>
                                      )}
                                    </td>
                                  </tr>
                                )
                              )}
                              {/* {emptyRows > 0 && (
                              <tr style={{ height: 34 * emptyRows }}>
                                <td colSpan={3} />
                              </tr>
                            )} */}
                            </tbody>
                            <tfoot>
                              <tr></tr>
                            </tfoot>
                          </table>
                          <div className="mt-3">
                            {"Items per Page: "}
                            <select
                              onChange={handlePageSizeChange}
                              value={pageSize}
                            >
                              {pageSizes.map((size) => (
                                <option key={size} value={size}>
                                  {size}
                                </option>
                              ))}
                            </select>

                            <Pagination
                              color="primary"
                              className="my-3"
                              count={count}
                              page={page}
                              siblingCount={1}
                              boundaryCount={1}
                              variant="outlined"
                              onChange={handlePageChange}
                            />
                          </div>
                        </>
                      )}
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {!userType && (
        <div
          className="fixed-bottom d-flex justify-content-end px-3"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: "10px",
          }}
        >
          {deleteArray2 && (
            <button
              className="btn btn-info  mr-4"
              onClick={() =>
                // deleteVideo()
                setModal4(true)
              }
              style={{ float: "left" }}
            >
              <DeleteIcon /> Delete Many
            </button>
          )}
        </div>
      )}
      <DeleteVideo
        // submit={submit}
        getData={getData}
        modal3={modal3}
        setModal3={setModal3}
        // deleteArray2={deleteArray2}
        currentID={currentID}
      />
      <DeleteVideoMany
        // submit={submit}
        getData={getData}
        modal4={modal4}
        setModal4={setModal4}
        deleteArray2={deleteArray2}
      // currentID={currentID}
      />
    </body>
  );
}

export default Videos;
